import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import {Route, Switch, useHistory, useLocation,} from 'react-router-dom';
import types from 'common/types';
import styles from './styles.module.scss';

if (process.env.NODE_ENV !== 'test') Modal.setAppElement('#root');

const AbstractModalView = ({
                             triggerContent,
                             modalContent,
                             subPath: subPathStr = 'info',
                             overlayClassName,
                             modalClassName,
                             modalContainerClassName,
                             onCloseModal,
                             shouldCloseOnOverlayClick = true,
                           }) => {
  const subPath = (subPathStr.startsWith('/')) ? subPathStr : `/${subPathStr}`;
  const location = useLocation();
  const history = useHistory();
  const path = location.pathname.replace(subPath, '');
  const routePath = (path === '/') ? '' : path;
  const contentDirection = 'rtl';

  const openModal = () => history.push(`${routePath}${subPath}`);

  const closeModal = () => {
    if (onCloseModal) {
      onCloseModal();
    }
    history.push(routePath);
  };

  return (
    <>
      {triggerContent({openModal, closeModal})}
      <Switch>
        <Route path={`${routePath}${subPath}`}>
          <Modal
            isOpen={true}
            onRequestClose={closeModal}
            className={`${styles.modal} ${styles[contentDirection]} ${modalClassName}`}
            overlayClassName={`${styles.overlay} ${overlayClassName}`}
            shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
          >
            <div dir={contentDirection}
                 className={`${modalContainerClassName}`}>
              {modalContent({closeModal})}
            </div>
          </Modal>
        </Route>
      </Switch>
    </>
  );
};

const {children} = types.children;

AbstractModalView.propTypes = {
  triggerContent: children,
  modalContent: children,
  subPath: PropTypes.string,
  overlayClassName: PropTypes.string,
  modalClassName: PropTypes.string,
  modalContainerClassName: PropTypes.string,
  onCloseModal: PropTypes.func,
  shouldCloseOnOverlayClick: PropTypes.bool,
};

export default AbstractModalView;
